/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { AxiosInstance } from 'axios';

import { AuthAPI, baseUrl, logoutUrl } from '../../common/authAPI';
import { sleepForever } from '@utils/time';

export const authClient = (request: AxiosInstance): AuthAPI => ({
  async logout() {
    window.location.href = logoutUrl;
    await sleepForever(); // stop application progress and wait for redirect to take effect
  },

  async login(redirectUrl: string) {
    window.location.href = `${baseUrl}/login?redirectUrl=${encodeURIComponent(redirectUrl)}`;
    await sleepForever();
  },

  async ping() {
    await request.get(`${baseUrl}/ping`);
  },

  async expire() {
    window.location.href = `${baseUrl}/expire`;
    await sleepForever(); // stop application progress and wait for redirect to take effect
  },
});
